import axios from 'axios'

function Get(url,data,callback){
    axios.get(url,{params:data}).then(function (response) {
        callback(response);
    }).catch(function(err){
        console.log(err);
    })
}

export default  Get;



// WEBPACK FOOTER //
// ./src/api/get.js